import { ConfigProvider } from 'antd';
import React, { ReactNode } from 'react';

interface IAntConfigProvider {
    children: ReactNode;
}

const AntConfigProvider: React.FC<IAntConfigProvider> = ({ children }) => {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Progress: {
                        lineBorderRadius: 0,
                    },
                    Form: {
                        itemMarginBottom: 0,
                        labelColonMarginInlineEnd: 0,
                        verticalLabelPadding: '2px 0 0',
                    },
                    Tabs: {
                        cardPaddingSM: '0px 35px',
                        horizontalMargin: '0 0 0px 0px',
                        // verticalItemMargin: '160px 0 0 0'
                    },
                    Collapse: {
                        contentPadding: '0px',
                        headerPadding: '10px 0px 0px',
                    },
                    DatePicker: {
                        zIndexPopup: 3000,
                    },
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
};

export default AntConfigProvider;
